/**
 * "Pixel Jump" 404 mini-game.
 *
 * No-ops unless the 404 template's canvas is present on the page.
 */
(function () {
	var cv = document.getElementById('pixel-jump-game');
	if (!cv) {
		return;
	}

	var WIN_TIME = 60; // seconds to survive
	var BG = '#253746'; // colors.$cmn-dark-grey
	var PX = '#1c9ed6'; // colors.$cmn-light-blue
	var YEL = '#ffcb05'; // colors.$cmn-yellow
	var WHT = '#ffffff';
	var BSK = '#40799f';

	var cx = cv.getContext('2d');
	var homeBtn = document.getElementById('pixel-jump-home');
	var hint = document.getElementById('pixel-jump-hint');
	var HINT_PLAY = 'Tap / click / spacebar to jump · survive 60 seconds';
	var HINT_WIN = 'Tap the game to play again';
	var W = cv.width, H = cv.height;
	var GROUND = 150;

	// player: 6 x 8, two run frames + jump frame
	var RUN_A = [
		'.XXXX.',
		'.XXXX.',
		'..XX..',
		'.XXXX.',
		'.XXXX.',
		'..XX..',
		'.X..X.',
		'.X..X.'
	];
	var RUN_B = [
		'.XXXX.',
		'.XXXX.',
		'..XX..',
		'.XXXX.',
		'.XXXX.',
		'..XX..',
		'..XX..',
		'.X.X..'
	];
	var JUMP = [
		'.XXXX.',
		'.XXXX.',
		'..XX..',
		'XXXXXX',
		'.XXXX.',
		'..XX..',
		'.X..X.',
		'X....X'
	];

	// 404 glyphs used as obstacles + backdrop
	var G4 = ['X..X', 'X..X', 'XXXX', '...X', '...X'];
	var G0 = ['.XX.', 'X..X', 'X..X', 'X..X', '.XX.'];

	// celebration balloon — yellow teardrop ring with a
	// transparent teardrop cutout, tapered tip, blue basket
	var BALLOON = [
		'...YYYYYY...',
		'..YYYYYYYY..',
		'.YYYYYYYYYY.',
		'.YYY....YYY.',
		'YYY......YYY',
		'YYY......YYY',
		'YYY......YYY',
		'YYY......YYY',
		'.YYY....YYY.',
		'.YYY....YYY.',
		'..YYY..YYY..',
		'..YYYYYYYY..',
		'...YYYYYY...',
		'....YYYY....',
		'.....YY.....',
		'............',
		'....BBBB....',
		'....BBBB....'
	];

	function drawGrid(grid, x, y, s, colorsMap) {
		for (var r = 0; r < grid.length; r++) {
			for (var c = 0; c < grid[r].length; c++) {
				var ch = grid[r][c];
				if (ch === '.') continue;
				cx.fillStyle = colorsMap[ch] || colorsMap.X || PX;
				cx.fillRect(x + c * s, y + r * s, s, s);
			}
		}
	}

	// state
	var state = 'start'; // start | play | dead | win
	var player, obstacles, speed, spawnIn, elapsed, animT, confetti, winT;

	function reset() {
		player = { x: 36, y: GROUND - 16, vy: 0, w: 12, h: 16, onGround: true };
		obstacles = [];
		speed = 2.1;
		spawnIn = 1.4;
		elapsed = 0;
		animT = 0;
		winT = 0;
		confetti = [];
		homeBtn.classList.remove('show');
		hint.textContent = HINT_PLAY;
	}
	reset();

	// input
	function jump() {
		if (state === 'start') {
			state = 'play';
			return;
		}
		if (state === 'dead' || state === 'win') {
			reset();
			state = 'play';
			return;
		}
		if (state === 'play' && player.onGround) {
			player.vy = -5.6;
			player.onGround = false;
		}
	}
	window.addEventListener('keydown', function (e) {
		if (e.code === 'Space' || e.code === 'ArrowUp') {
			e.preventDefault();
			jump();
		}
	});
	cv.addEventListener('pointerdown', function (e) {
		e.preventDefault();
		jump();
	});

	// update
	function spawn() {
		var glyph = Math.random() < 0.5 ? G4 : G0;
		var s = 4;
		obstacles.push({
			x: W + 10, y: GROUND - glyph.length * s, g: glyph, s: s,
			w: glyph[0].length * s, h: glyph.length * s
		});
		spawnIn = 0.9 + Math.random() * 1.1;
	}

	function update(dt) {
		if (state !== 'play') {
			if (state === 'win') {
				winT += dt;
				for (var i = confetti.length - 1; i >= 0; i--) {
					var p = confetti[i];
					p.y += p.vy * dt * 60;
					p.x += p.vx * dt * 60;
					p.vy += 0.05;
					if (p.y > H + 8) confetti.splice(i, 1);
				}
				if (confetti.length < 60 && Math.random() < 0.4) {
					confetti.push({
						x: Math.random() * W, y: -6,
						vx: (Math.random() - 0.5) * 0.8, vy: 0.6 + Math.random() * 1.2,
						c: [YEL, PX, WHT][Math.floor(Math.random() * 3)], s: 2 + Math.floor(Math.random() * 2) * 2
					});
				}
			}
			return;
		}

		elapsed += dt;
		animT += dt;
		speed += dt * 0.045;

		// player physics
		player.vy += 18 * dt;
		player.y += player.vy * dt * 60;
		if (player.y >= GROUND - player.h) {
			player.y = GROUND - player.h;
			player.vy = 0;
			player.onGround = true;
		}

		// obstacles
		spawnIn -= dt;
		if (spawnIn <= 0) spawn();
		for (var j = obstacles.length - 1; j >= 0; j--) {
			var o = obstacles[j];
			o.x -= speed * dt * 60;
			if (o.x + o.w < -10) {
				obstacles.splice(j, 1);
				continue;
			}
			// forgiving hitbox
			if (player.x + 2 < o.x + o.w - 2 && player.x + player.w - 2 > o.x + 2 &&
				player.y + 2 < o.y + o.h - 2 && player.y + player.h - 2 > o.y + 2) {
				state = 'dead';
			}
		}

		if (elapsed >= WIN_TIME) {
			state = 'win';
			obstacles = [];
			homeBtn.classList.add('show');
			hint.textContent = HINT_WIN;
		}
	}

	// draw
	function text(str, x, y, size, color, align) {
		cx.fillStyle = color;
		cx.font = 'bold ' + size + "px 'Courier New', monospace";
		cx.textAlign = align || 'center';
		cx.fillText(str, x, y);
	}

	function drawWin() {
		// balloon rises, then settles between two yellow 4s: 4 [balloon] 4
		var by = Math.max(14, 84 - winT * 40);
		var bx = W / 2 - 24; // balloon is 12 cols * 4px = 48 wide

		// flanking yellow 4s fade in as balloon settles
		var fade = Math.min(1, Math.max(0, (winT - 0.5) / 0.5));
		if (fade > 0) {
			cx.globalAlpha = fade;
			drawGrid(G4, bx - 46, 32, 8, { X: YEL });
			drawGrid(G4, bx + 62, 32, 8, { X: YEL });
			cx.globalAlpha = 1;
		}

		drawGrid(BALLOON, bx, by, 4, { Y: YEL, B: BSK });

		for (var i = 0; i < confetti.length; i++) {
			var p = confetti[i];
			cx.fillStyle = p.c;
			cx.fillRect(p.x, p.y, p.s, p.s);
		}

		if (winT > 0.8) {
			text('BONUS ROUND COMPLETE.', W / 2, 124, 15, YEL);
			text('Back to the real mission.', W / 2, 144, 10, WHT);
			text('TAP TO PLAY AGAIN', W / 2, 168, 8, PX);
		}
	}

	function draw() {
		cx.fillStyle = BG;
		cx.fillRect(0, 0, W, H);

		if (state === 'win') {
			drawWin();
			return;
		}

		// faint 404 backdrop
		cx.globalAlpha = 0.08;
		drawGrid(G4, 92, 40, 8, { X: PX });
		drawGrid(G0, 140, 40, 8, { X: PX });
		drawGrid(G4, 188, 40, 8, { X: PX });
		cx.globalAlpha = 1;

		// ground
		cx.fillStyle = PX;
		cx.fillRect(0, GROUND, W, 2);

		// player
		var frame = !player.onGround ? JUMP : (Math.floor(animT * 10) % 2 ? RUN_A : RUN_B);
		drawGrid(frame, player.x, player.y, 2, { X: PX });

		// obstacles
		for (var i = 0; i < obstacles.length; i++) {
			var o = obstacles[i];
			drawGrid(o.g, o.x, o.y, o.s, { X: PX });
		}

		// timer — yellow for the final 10 seconds
		if (state === 'play' || state === 'dead') {
			var left = Math.max(0, Math.ceil(WIN_TIME - elapsed));
			text(left + 's', W - 10, 20, 12, left <= 10 ? YEL : WHT, 'right');
		}

		if (state === 'start') {
			text('PIXEL JUMP', W / 2, 78, 16, PX);
			text('TAP OR PRESS SPACE TO START', W / 2, 98, 9, WHT);
			text('SURVIVE 60 SECONDS', W / 2, 114, 8, 'rgba(255,255,255,0.55)');
		}

		if (state === 'dead') {
			text('OUCH.', W / 2, 84, 16, PX);
			text('TAP TO TRY AGAIN', W / 2, 104, 9, WHT);
		}
	}

	// loop
	var last = performance.now();
	function loop(now) {
		var dt = Math.min((now - last) / 1000, 0.05);
		last = now;
		update(dt);
		draw();
		requestAnimationFrame(loop);
	}
	requestAnimationFrame(loop);
})();
